import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '@/locales/en/translation.json';
import translationES from '@/locales/es/translation.json';
import translationPT from '@/locales/pt/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
  pt: {
    translation: translationPT,
  },
};

const VALID_LANGUAGES = ['es', 'en', 'pt'];
const storedLang = window.localStorage.getItem('language') ?? '';
const initialLang = VALID_LANGUAGES.includes(storedLang) ? storedLang : 'es';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'es',
  });

export default i18n;
